<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="width: 640px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <b-field label="ID" v-if="id">
          <b-input placeholder="ID" disabled v-model="model.id"></b-input>
        </b-field>
        <b-field
          label="Наименование">
          <b-input
            name="name"
            placeholder="Наименование"
            icon="user"
            v-model="model.name">
          </b-input>
        </b-field>
        <b-field
          label="Значение">
          <b-input
            name="value"
            type="number"
            placeholder="Описание"
            icon="user"
            v-model="model.value">
          </b-input>
        </b-field>
        <b-field
          label="Описание">
          <b-input
            name="description"
            placeholder="Описание"
            icon="user"
            v-model="model.description">
          </b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">Сохранить</button>        
        <button class="button" type="button" @click="$parent.close()">Закрыть</button>
      </footer>
    </div>
  </form>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, {
    events: '',
});

import {EventBus} from '@/utils'

export default {
  name: 'TypeForm',
  components: {
    //
  },
  props: {
    id: Number,
    title: String
  },
  data: function () {
    return {
      confirmPassword: '',
      model: {
        id: undefined,
        name: '',
        title: '',
        another_title: '',
        color: undefined
      },
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this

    if ($this.id){
      this.$store.dispatch('getType', $this.id)
        .then(response => {
          let data = response.data.data;
          $this.model = data
        })
        .catch(error => {
          this.model = {}
        })
    }
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          $this.doUpdate()
          return;
        }
        this.$toast.open({
          message: $this.$i18n.t('notify.form_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      });
    },
    doUpdate () {
      let $this = this
      if ($this.id){
        $this.$store.dispatch('updateType', $this.model)
      }
      else{
        $this.$store.dispatch('createType', $this.model)
      }
    }
    
  }
}
</script>

<style scoped>
</style>
<style>
</style>